export const NO_RESULT_ID = "11111111-1111-1111-1111-111111111111";
